import React from 'react'
import { useParams } from 'react-router-dom'
import ApprovalWorkflowsTab from './components/ApprovalWorkflowsTab'
import EmailTemplatesTab from './components/EmailTemplatesTab'
import DeliveryAuditLogsTab from './components/DeliveryAuditLogsTab'
import EmailAccountTab from './components/EmailAccountTab'
import './emailSettings.css'

export default function EmailNotificationSettingsScreen() {
  const { tab = 'workflows' } = useParams()

  const normalizedTab = String(tab || 'workflows').toLowerCase()

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-28 pt-2">
      {normalizedTab === 'workflows' && <ApprovalWorkflowsTab />}
      {normalizedTab === 'templates' && <EmailTemplatesTab />}
      {normalizedTab === 'audit-logs' && <DeliveryAuditLogsTab />}
      {normalizedTab === 'account' && <EmailAccountTab />}
    </div>
  )
}
